import { QueryParams } from 'interfaces/query.interfaces';

export const generateQueryString = (query: QueryParams) =>
  Object.keys(query)
    .map((queryKey) => `&${queryKey}=${query[queryKey] ?? ''}`)
    .join('');
